<template>
  <div class="section-margin">
    <div v-if="spinner">
      <div class="spinner">
          <breeding-rhombus-spinner
          :size="65"
          color="#EA771D"
          />
      </div>
    </div>
    <div v-else class="container">
      <div id="header-program">
        <h2 class="title title-w" >Programa</h2>
        <div class="separator-title"></div>
      </div>
      <div class ="containerImg">
          <img :src="this.imgProgram">
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { BreedingRhombusSpinner } from 'epic-spinners';

export default {
    name:'Program',
    components:{
        BreedingRhombusSpinner,
        },

  
  data() {
    return {
      title: 'Program',
      users: [],
      spinner: true,
      imgProgram: '',
      fecha: '',
      programa: {},
      days: 0,
      temporal: {},
      firebaseInformacion: {},
    };
  },
  methods: {
    setData() {
      const starCountRef = firebase.database().ref('/programa');
      starCountRef.once('value', (snapshot) => {
        this.imgProgram = snapshot.val().imagen;

        this.spinner = false;
      });
    },
  },
  mounted() {
    this.setData();
  },
};
</script>


<style>
@import './Program.css';
</style>




// WEBPACK FOOTER //
// src/components/program/Program.vue